export default {"src":"/_next/static/image/src/images/statistic-assets.02e4fdfe9b99d62d50c458a97512c1cf.svg","height":32,"width":32};